/**
 * UI and Layout related constants used across the application
 */

// PII Masking
export const MASK_LENGTH = 5;

/** Message shown while opening the Stripe billing portal in a new tab (e.g. for model add-ons). */
export const BILLING_PORTAL_OPENING_MESSAGE = 'Opening billing page...';

// Form Field Layouts
export const FIELD_VERTICAL_LAYOUT_THRESHOLD = 100;

/**
 * Stacking for portaled `position: fixed` UI (inline `zIndex`). Many routes use Tailwind
 * `z-50` / `z-[100]` for modals and toasts; these values sit above in-document stacks.
 */
export const Z_INDEX_PORTAL_TOOLTIP = 9_999;
/** Confidence score hover card — same family as tooltips but above them when both portaled. */
export const Z_INDEX_CONFIDENCE_HOVER_PANEL = 10_000;
